// storeReserveController
import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import apiResponses from './storeReserve.json';

const storeReserveInitPage = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['storeReserveController/storeReserveInitPage'].success.default)));
};

const getAvailableStoresByAreaAndCity = (req, res, ctx) => {
  return res(
    ctx.json(mockResponse(apiResponses['storeReserveController/getAvailableStoresByAreaAndCity'].success.default))
  );
};

const getAvailableReserveDateAndTime = (req, res, ctx) => {
  return res(
    ctx.json(mockResponse(apiResponses['storeReserveController/getAvailableReserveDateAndTime'].success.default))
  );
};

export const handlers = [
  rest.post(
    getApiEndpoint('storeReserveController/storeReserveInitPage'),
    withScenario(withAuthCheck(storeReserveInitPage))
  ),
  rest.post(
    getApiEndpoint('storeReserveController/getAvailableStoresByAreaAndCity'),
    withScenario(withAuthCheck(getAvailableStoresByAreaAndCity))
  ),
  rest.post(
    getApiEndpoint('storeReserveController/getAvailableReserveDateAndTime'),
    withScenario(withAuthCheck(getAvailableReserveDateAndTime))
  ),
];
